import React, { useState } from 'react';

export default function AdminManagement({ admins, onAddAdmin }) {
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('admin');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim() || !username.trim() || !password.trim() || !email.trim()) {
      setError('Please fill in all fields.');
      setSuccess('');
      return;
    }

    if (!/^\S+@\S+\.\S+$/.test(email.trim())) {
      setError('Please enter a valid email address.');
      setSuccess('');
      return;
    }

    const usernameTaken = admins.some(
      (a) => a.username.toLowerCase() === username.trim().toLowerCase()
    );
    if (usernameTaken) {
      setError('Username already exists. Please choose a different one.');
      setSuccess('');
      return;
    }

    // Call callback to add
    onAddAdmin({
      name: name.trim(),
      username: username.trim(),
      password: password.trim(),
      email: email.trim(),
      role,
    });

    // Reset form
    setName('');
    setUsername('');
    setPassword('');
    setEmail('');
    setRole('admin');
    setError('');
    setSuccess('New administrator account created successfully! 🎉');

    setTimeout(() => setSuccess(''), 4000);
  };

  return (
    <div className="admin-mgmt-container animate-fade">
      <div className="admin-mgmt-header">
        <div className="admin-mgmt-title">
          <h2>🛡️ System Access Controls</h2>
          <p>Super Admin Console — Create and manage hospital admin credentials</p>
        </div>
      </div>

      <div className="admin-mgmt-grid">
        {/* Create Admin Form */}
        <div className="admin-mgmt-card glass-card">
          <h3>Create Administrator Account</h3>
          <p className="section-subtitle">Grant secure system access to clinical staff</p>

          <form onSubmit={handleSubmit} className="admin-create-form">
            {error && <div className="form-error-banner">⚠️ {error}</div>}
            {success && <div className="form-success-banner">✅ {success}</div>}

            <div className="form-group">
              <label className="form-label" htmlFor="admin-name">Full Name</label>
              <input
                id="admin-name"
                type="text"
                className="form-control"
                placeholder="e.g. Dr. Sarah Connor"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="admin-username">Username</label>
              <input
                id="admin-username"
                type="text"
                className="form-control"
                placeholder="e.g. sarahconnor"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="admin-password">Password</label>
              <input
                id="admin-password"
                type="password"
                className="form-control"
                placeholder="Minimum 6 characters"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="admin-email">Email Address</label>
              <input
                id="admin-email"
                type="email"
                className="form-control"
                placeholder="e.g. admin@hospital.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="admin-role">System Access Level</label>
              <select
                id="admin-role"
                className="form-control"
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value="admin">Admin (View & Edit Patient Records)</option>
                <option value="superadmin">Super Admin (Full Access + Delete & Manage Admins)</option>
              </select>
            </div>

            <button type="submit" className="btn btn-primary btn-block" style={{ marginTop: '12px' }}>
              + Create Staff Access
            </button>
          </form>
        </div>

        {/* Existing Admins List */}
        <div className="admin-mgmt-card glass-card">
          <h3>Active Administrative Accounts</h3>
          <p className="section-subtitle">List of clinic staff currently authorized to view or manage records</p>

          <div className="admin-list-table-wrapper">
            <table className="admin-list-table">
              <thead>
                <tr>
                  <th>Staff Member</th>
                  <th>Username</th>
                  <th>Email</th>
                  <th>Security Role</th>
                </tr>
              </thead>
              <tbody>
                {admins.map((a) => (
                  <tr key={a.username}>
                    <td>
                      <div className="admin-member-cell">
                        <div className="admin-avatar">{a.name?.[0] || 'A'}</div>
                        <div className="admin-member-name">{a.name}</div>
                      </div>
                    </td>
                    <td><code>{a.username}</code></td>
                    <td><code>{a.email || 'not configured'}</code></td>
                    <td>
                      <span className={`badge ${a.role === 'superadmin' ? 'badge-danger' : 'badge-primary'}`}>
                        {a.role === 'superadmin' ? '👑 Super Admin' : '🛡️ Admin'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
